import ResponsiveImage from "components/ui/ResponsiveImage/ResponsiveImage";

function LeftSlide({ content }) {
  return (
    <div className={ 'slide-grid' }>
      <div className={ 'slide-grid__full-width-image slide-grid__margin-bottom' }>
        { content.field_slide_1_image_1.value &&
        <ResponsiveImage value={ content.field_slide_1_image_1.value }/>
        }
      </div>

      <div className={ 'slide-grid__image-and-quote' }>
        <div className={ 'slide-grid__small-image slide-grid__margin-right' }>
          { content.field_slide_1_image_2.value &&
          <ResponsiveImage value={ content.field_slide_1_image_2.value }/>
          }
        </div>

        <div className={ 'slide-grid__quote slide-grid__quote--orange slide-grid__margin-left' }>
          { content.field_slide_1_quote.value &&
            <>”{ content.field_slide_1_quote.value }”</>
          }
        </div>
      </div>
    </div>
  );
}

export default LeftSlide;
